<template>
    <!--    服务信息-->
    <div class="user-information">
        <OrderCaption title="用户信息" :capIcon="findIcon"/>
        <div class="information-container">
            <Chunk title="姓名" wid56 :desc="infos.name"/>

            <Chunk title="性别" wid56 :desc="infos.sexDesc"/>

            <Chunk title="年龄" wid56 :desc="`${infos.age}岁`"/>

            <Chunk title="症状" wid56 :desc="infos.symptoms"/>

            <Chunk v-if="infos.remark" title="备注" wid56 :desc="infos.remark"/>

            <Chunk title="既往病史" v-if="infos.medicalHistory">
                <template v-slot:context>
                    <div class="chunk_desc van-hairline--surround">
                        {{infos.medicalHistory}}
                    </div>
                </template>
            </Chunk>

            <div class="medical" v-if="infos.medicalRecord && infos.medicalRecord.length > 0">
                <div class="medical-title">病历</div>
                <div class="medical-history">
                    <MedicalRecord :list="infos.medicalRecord" @callBack="lookPhoto"/>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
    import OrderCaption from '@/components/OrderCaption/OrderCaption.vue'
    import Chunk from '@/components/Chunk/Chunk.vue';
    import MedicalRecord from '@/components/medicalRecord/MedicalRecord.vue';
    import {dataBuryingPoint} from '@/utils/JSBridge.js'
    import findIcon from './img/icon_2.png'

    export default {
        props: {
            orderSource: Number,
            infos: {
                name: '', // 姓名
                age: '', // 年龄
                symptoms: '', // 症状
                remark: '', // 备注
                address: '', // 服务地点
                skillLabels: '', // 服务标签
                medicalHistory: '', // 病史
                explain: '', // 表述
                medicalRecord: [], // 病历

            },
        },
        data() {
            return {
                findIcon: findIcon,
            }
        },
        methods: {
            lookPhoto() {
                // 查看图片埋点
                dataBuryingPoint('C000004', 'C000004-004', {orderSource: this.orderSource});
            },
        },
        components: {OrderCaption, Chunk, MedicalRecord}
    }
</script>
<style lang="scss" scoped>
    .user-information {
        .information-title {
            display: flex;
            align-items: center;
            padding: 20px 16px;
            font-size: 17px;
            font-weight: 400;
            color: rgba(34, 34, 34, 1);

            .title_icon {
                width: 16px;
                margin-right: 10px;
            }
        }

        .information-container {
            padding: 0 16px;

            .chunk_desc {
                flex-shrink: 1;
                flex-wrap: wrap;
                background: rgba(252, 252, 252, 1);
                font-size: 15px;
                font-weight: 400;
                color: rgba(34, 34, 34, 1);
                padding: 10px;
                line-height: 20px;
            }

            .chunk_medical {
                overflow-y: scroll;
                white-space: nowrap;
                font-size: 0;

                & > li {
                    display: inline-block;
                    margin-right: 13px;
                    width: 127px;
                    height: 90px;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center center;
                    position: relative;

                    .history_tip {
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        width: 100%;
                        background: rgba(73, 69, 83, 1);
                        opacity: 0.8;
                        font-size: 11px;
                        font-weight: 300;
                        color: rgba(255, 255, 255, 1);
                        line-height: 20px;
                        text-align: center;
                    }
                }
            }

            .medical {
                padding-top: 15px;
                padding-bottom: 23px;

                &-title {
                    font-size: 14px;
                    font-weight: 400;
                    color: #69707f;
                    margin-right: 0.13rem;
                }

                &-history {
                    padding-top: 12px;
                }
            }
        }
    }
</style>
